<div class="information-box">
    <img src="assets/info-icon.svg" alt="info icon">
  <div class="content">
    <h2 class="information-box__title">Information</h2>
  <span
    class="information-box__message"
    [innerHTML]="content"
  ></span>
  </div>

</div>
